import {BundleSummaryData} from "../productSummaryApi/bundle"
import {SuitSummaryData} from "../productSummaryApi/suit"
import {ProductSummaryData} from "../productSummaryApi/product"
import {SofaSummaryData} from "../productSummaryApi/sofa"
import {SaleSashPosition} from "../../config/constants"

export enum FavErrorToolTipType {
    MaxLimit,
    Error,
}

export interface ColourChipConfig {
    lg: number
    xl: number
}

export type SummaryData = ProductSummaryData | SuitSummaryData | SofaSummaryData | BundleSummaryData

export interface ProductSummaryState {
    enableReviewStars: boolean
    enabledSearchDesc: boolean
    summaryItemsData: {[key: string]: SummaryData}
    enableBrandDisplay: boolean
    enableSingleLineTitle: boolean
    enableSingleLineBrandName: boolean
    mobileThumbnailConfig: MobileThumbnailConfig
    colourChipConfig: ColourChipConfig
    maxNumberOfSofaColourways: number | null
    maxNumberOfHomewareColourways: number | null
    imageRatio: string
    brandedMarkdownSalePrice: boolean
    akamaiImageParams: AkamaiImageParams
    displayFitIcons: boolean
    displayNewIn: boolean
    saleSash: string | null
    saleSashPosition: SaleSashPosition
    imageCdnUrl: string
    productImageUrlPart: string
    lgImagePath: string
    usePDPImage: boolean
    savingsSashConfig: SavingsSashConfig
    enableFurtherReductionsSash: boolean
    enableQuickAddToBag: boolean
    bundlePriceLabel?: string
}

export interface AkamaiImageParams {
    lg: string
    sm: string
}

export interface MobileThumbnailConfig {
    xs: number
    sm: number
    md: number
}

export interface ColourChip {
    itemNumber: string
    colourChipUrl: string
    linkUrl: string
    isSelected: boolean
    colour: string
    title: string
    price: string
    currencyCode: string
    altText: string
    department: string
}

export interface ImageCdnUrlParts {
    imageCdnUrl: string
    productImageUrlPart: string
    lgImagePath: string
    usePDPImage: boolean
}

export interface Imagery {
    folder: string
    akamaiImageManagerParams: AkamaiImageParams
    dimension: string
    ratio: string
    usePDPImage: boolean
}

export interface SavingsSashConfig {
    sale: number
    clearance: number
}
